import { FacebookFilled, InstagramFilled, LinkedinFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { useViewport } from "@bindeleddet/core/hooks";
import { ContactLink, SocialIconLink, SocialLinksCol } from "./FooterSocialLinks.styled";

import { FOOTER_BREAKPOINT } from "../constants";

const { Paragraph } = Typography;

const FooterSocialLinks = () => {
  const { width } = useViewport();

  return (
    <SocialLinksCol
      span={width < FOOTER_BREAKPOINT ? 24 : 9}
      style={width < FOOTER_BREAKPOINT ? {} : { textAlign: "right" }}
    >
      <Paragraph>
        <SocialIconLink href="https://www.facebook.com/bindeleddet.ntnu/?fref=ts">
          <FacebookFilled />
        </SocialIconLink>
        <SocialIconLink href="https://www.instagram.com/bindeleddet/">
          <InstagramFilled />
        </SocialIconLink>
        <SocialIconLink href="https://www.linkedin.com/company/bindeleddet-ntnu">
          <LinkedinFilled />
        </SocialIconLink>
      </Paragraph>
      <ContactLink href="mailto:kontakt@bindeleddet.no">kontakt@bindeleddet.no</ContactLink>
    </SocialLinksCol>
  );
};

export default FooterSocialLinks;
